import { render, staticRenderFns } from "./ApplicationStore.vue?vue&type=template&id=0c963de0&scoped=true&"
import script from "./ApplicationStore.vue?vue&type=script&lang=ts&"
export * from "./ApplicationStore.vue?vue&type=script&lang=ts&"
import style0 from "./ApplicationStore.vue?vue&type=style&index=0&id=0c963de0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c963de0",
  null
  
)

export default component.exports